import React, { useState, useEffect, useContext } from "react";
import NativeVideo from "nativevideo-sdk-js";
import { useParams } from "react-router-dom";
import Layout from "../components/Layout/Layout";
import OrgChat from "../components/OrgChat";
import { SubscribersContext } from "../context/subscribersContext";
import { RegionContext } from "../context/regionContext";
import { SubscriberData } from "types/subscriberData";
import "./App.scss";

function SubscriberVecna() {
  const { subscribersData } = useContext(SubscribersContext);
  const { regionUrl } = useContext(RegionContext);

  const [nvObj, setnvObj] = useState<NativeVideo>();
  const [subscriberId, setSubscriberId] = useState<string>();
  const [
    selectedSubscriberData,
    setSelectedSubscriberData,
  ] = useState<SubscriberData | null>(null);
  let params = useParams();

  useEffect(() => {
    if (params) setSubscriberId(params.id);
  }, [params]);

  useEffect(() => {
    if (subscribersData && subscriberId && regionUrl) {
      let selectedSubscriber = subscribersData.find(
        sub => sub.subscriberId === subscriberId
      );
      setnvObj(
        new NativeVideo({
          subscriberAuthToken: selectedSubscriber.authToken,
          backendUrl: regionUrl,
          adminAuthToken: localStorage.getItem("loginToken") as
            | string
            | undefined,
        })
      );
    }

    if (subscribersData && subscriberId) {
      setSelectedSubscriberData(
        subscribersData.find(o => o.subscriberId === subscriberId)
      );
    }
  }, [subscribersData, subscriberId, regionUrl]);

  return (
    <Layout>
      <OrgChat
        nvObj={nvObj}
        subscriberId={subscriberId}
        organizationName={selectedSubscriberData?.organizationName}
      />
    </Layout>
  );
}

export default SubscriberVecna;
